import { render, staticRenderFns } from "./PostsPerHourChart.vue?vue&type=template&id=5f627b32&scoped=true&"
import script from "./PostsPerHourChart.vue?vue&type=script&lang=js&"
export * from "./PostsPerHourChart.vue?vue&type=script&lang=js&"
import style0 from "./PostsPerHourChart.vue?vue&type=style&index=0&id=5f627b32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f627b32",
  null
  
)

export default component.exports